<svg-icon [src]="'/assets/img/' + statusIcon + '.svg'"></svg-icon>
